import { load } from "@syncfusion/ej2-react-grids";
import {
  getAgingListApi,
  getAllListApi,
  getFinalReportApi,
  getLiquidationListApi,
  getMasterAgingDiscountApi,
} from "../services/barCodeMaster";
import { create } from "zustand";

export const useBarcodeStore = create((set) => ({
  loading: false,
  masterList: [],
  agingList: [],
  liquidationList: [],
  finalList: [],

  setLoading: (value) => set({ loading: value }),
  // Actions
  getBarcodeMaster: async (divisionCode, departmentCode) => {
    set({ loading: true });
    try {
      const response = await getMasterAgingDiscountApi(
        divisionCode,
        departmentCode,
      );
      const formattedData = response?.Data.map((element, index) => ({
        ...element,
        serialNo: index + 1,
      }));
      set({ masterList: formattedData || [] });
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ masterList: [] });
    } finally {
      set({ loading: false });
    }
  },
  addExpiryDiscount: async (payload) => {
    set({ loading: true });
    try {
      const response = await postItemNearToExpiryDiscountApi(payload);
      return response?.data;
    } catch (error) {
      console.error("Error fetching IRN list:", error);
    } finally {
      set({ loading: false });
    }
  },
  getAgingList: async (payload) => {
    set({ loading: true });
    try {
      const response = await getAgingListApi(payload);
      set({ agingList: response.Data || [] });

      return response?.Data;
    } catch (error) {
      console.error("Error fetching IRN list:", error);
      set({ agingList: [] });
    } finally {
      set({ loading: false });
    }
  },
  getAllList: async (payload) => {
    set({ loading: true });
    try {
      const response = await getAllListApi(payload);
      set({ allList: response.Data || [] });

      return response?.Data;
    } catch (error) {
      console.error("Error fetching all list:", error);
      set({ allList: [] });
    } finally {
      set({ loading: false });
    }
  },
  getLiquidationList: async (payload) => {
    set({ loading: true });
    try {
      const response = await getLiquidationListApi(payload);
      set({ liquidationList: response.Data || [] });
      return response?.Data;
    } catch (error) {
      console.error("Error fetching liquidation list:", error);
      set({ liquidationList: [] });
    } finally {
      set({ loading: false });
    }
  },
  getFinalList: async (payload) => {
    set({ loading: true });
    try {
      const response = await getFinalReportApi(payload);
      set({ finalList: response.Data || [] });

      return response?.Data;
    } catch (error) {
      console.error("Error fetching final List :", error);
      set({ finalList: [] });
    } finally {
      set({ loading: false });
    }
  },
}));
